/** An account's icon: the machine's own sign-in, a subscription, a key or a cloud provider. */
import { Building2, Cloud, KeyRound, UserRound } from '@orgus/ui/icons';
import type { LucideIcon } from '@orgus/ui/icons';
import type { LaunchAccount, LaunchAccountKind } from '@orgus/protocol';
import { cn } from '@orgus/ui';

const ICON: Record<LaunchAccountKind, LucideIcon> = { subscription: Building2, 'api-key': KeyRound, foundry: Cloud, bedrock: Cloud, vertex: Cloud };

export function Glyph({ a, className }: { a: Pick<LaunchAccount, 'kind' | 'builtIn'>; className?: string }) {
  const Icon = a.builtIn ? UserRound : ICON[a.kind];
  return (
    <span aria-hidden className={cn('flex size-6 shrink-0 items-center justify-center rounded-control bg-active text-fg-muted', className)}>
      <Icon className="size-3.5" />
    </span>
  );
}
